import { AllCardsType } from '../../../data/all-cards'
import { NombreTarotista } from '../../../data/personality'
import { DataTypeVidaPasada } from '../../../interfaces/utils'
import { formatCardLabel } from '../../../utils/card-label'

export const interpret = (
    cards: AllCardsType[],
    data: DataTypeVidaPasada,
    user: string,
    personality: NombreTarotista,
    type: string
) => {
    let consult = `Por favor realiza la interpretación de la tirada de Vida Pasada para ${
        data.consultante.name
    }, teniendo en cuenta su signo de ${data.consultante.zodiac} con las siguientes cartas: ${formatCardLabel(cards[0])}, ${formatCardLabel(cards[1])}, ${formatCardLabel(cards[2])}, ${formatCardLabel(cards[3])}, ${formatCardLabel(cards[4])}, ${formatCardLabel(cards[5])} y ${formatCardLabel(cards[6])} en la identidad en la vida pasada (trata de definir que tipo de persona era, a que se dedicaba, si tenia estudios o no, estado civil, hijos y todo lo que más puedas extraer de estas cartas), ${formatCardLabel(cards[7])} y ${formatCardLabel(cards[8])} en ambiente y circunstacias, ${formatCardLabel(cards[9])} y ${formatCardLabel(cards[10])} en relaciones claves, ${formatCardLabel(cards[11])} y ${formatCardLabel(cards[12])} en desafíos principales, ${formatCardLabel(cards[13])} y ${formatCardLabel(cards[14])} en logros y éxitos, ${formatCardLabel(cards[15])} y ${formatCardLabel(cards[16])} en lección principal aprendida, ${formatCardLabel(cards[17])} y ${formatCardLabel(cards[18])} en conexión de tu vida pasada con la vida actual,  ${formatCardLabel(cards[19])} y ${formatCardLabel(cards[20])} en patrones Kármicos recurrentes (Patrones de comportamiento o situaciones que se repiten en tu vida actual debido a esa vida pasada), ${formatCardLabel(cards[21])} y ${formatCardLabel(cards[22])} en sanación y liberación (lo que necesitas sanar de esa vida pasada para avanzar en la vida presente), ${formatCardLabel(cards[23])} y ${formatCardLabel(cards[24])} en consejo para el futuro. ${
        data.consulta.length > 0 ? 'Ten en cuenta en toda esta lectura lo siguiente:' + data.consulta + '.' : ''
    }. Dirígete directamente al consultante.`

    let info = {
        consult,
        user,
        personality,
        clientName: data.consultante.name,
        clientPhone: data.consultante.phone || '',
        clientAnswer: data.consulta,
        cards,
        type,
    }

    return info
}
